export default __webpack_public_path__ + "static/media/836.cc8582a9.png";